<template>
  <Modal
    sheetbelowsm
    close-button
    :title="$t('admin.security.root.change_confirm_title')"
    :primary-button="$t('admin.security.root.use_key')"
    :secondary-button="$t('cancel')"
    :primary-button-loading="loading"
    @primary="onConfirmClick"
    @secondary="onCancel"
    @close="onCancel"
  >
    <div class="sm:w-600 py-7 px-10">
      <div v-html="$t('admin.security.root.change_confirm_subtitle', { slot: slotName, fingerprint })"></div>
      <Checkbox v-model="rotateProjectKeys" :label="$t('admin.security.root.rotate_project_keys')" class="mt-5" />
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'RotateRootKeyModal',
  props: {
    slotName: {
      type: String,
    },
    fingerprint: {
      type: String,
    },
    onConfirm: {
      type: Function,
    },
  },
  emits: ['close'],
  data() {
    return {
      loading: false,
      rotateProjectKeys: false,
    };
  },
  methods: {
    /**
     * Switches to the new root key with the chosen option, then closes.
     * @returns {Promise<void>} Resolves once the change request finished.
     */
    async onConfirmClick() {
      this.loading = true;
      await this.onConfirm({ fingerprint: this.fingerprint, rotate_project_keys: this.rotateProjectKeys });
      this.loading = false;
      this.$emit('close');
    },
    /**
     * Closes without changing the key, unless the request is already running.
     * @returns {void}
     */
    onCancel() {
      if (!this.loading) this.$emit('close');
    },
  },
};
</script>
